import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  Redirect,
} from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faCoffee,
  faStore,
  faCalendarDay,
  faBuilding,
  faRupeeSign,
  faLock,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import { PopupMessage } from "../utils/utils";
import axios from "axios";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { clientAccess } from "../utils/index";
import "bootstrap/dist/css/bootstrap.css";
import apiUrl from "../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import TopHeader from "../layout/TopHeader";
import LeaseMenu from "./LeaseMenu";
import { hasAccess, getUserType } from "../utils/index";
import AssetDetails from "./assetDetails/AssetDetails";
import AcquisitionDetails from "./acquisitionDetails/AcquisitionDetails";
import AssetManagement from "./assetManagement/AssetManagement";
import Valuation from "./valuation/Valuation";
import LeaseListingTable from "./LeaseListingTable";
export default function CloseDeals() {
  let match = useRouteMatch();

  return (

    <div>
      <TopHeader />
      <div className="masterContainer">

        {hasAccess(["admin", "maker"]) && (
          <div className={window.location.pathname == "/close-deals" ? "" : "masterClassMain mt-4"}>
            <Switch>
              <Route path={`${match.path}/asset-details/:id`}>
                <LeaseMenu openMenu="1" activeKey="1-1" />
                <AssetDetails />
              </Route>
              <Route path={`${match.path}/asset-details`}>
                <LeaseMenu openMenu="1" activeKey="1-1" />
                <AssetDetails />
              </Route>




              <Route path={`${match.path}/acquisition-details/:id`}>
                <LeaseMenu openMenu="2" activeKey="2-1" />
                <AcquisitionDetails />
              </Route>
              <Route path={`${match.path}/acquisition-details`}>
                <LeaseMenu openMenu="2" activeKey="2-1" />
                <AcquisitionDetails />
              </Route>



              <Route path={`${match.path}/asset-management/:id`}>
                <LeaseMenu openMenu="3" activeKey="3-1" />
                <AssetManagement />
              </Route>
              <Route path={`${match.path}/asset-management`}>
                <LeaseMenu openMenu="1" activeKey="3-1" />
                <AssetManagement />
              </Route>

              <Route path={`${match.path}/valuation/:id`}>
                <LeaseMenu openMenu="4" activeKey="4-1" />
                <Valuation />
              </Route>
              <Route path={`${match.path}/valuation`}>
                <LeaseMenu openMenu="1" activeKey="4-1" />
                <Valuation />
              </Route>

              <Route path={`/close-deals`}>
                <LeaseListingTable />
              </Route>

            </Switch>
          </div>
        )}
        {/* <LeaseListingTable/> */}
      </div>
    </div>
  );
}
